import React, { useCallback, useEffect, useState } from 'react';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import './StylePicker.css';

const StylePicker = ({ selectedTemplateId, onSelect, disabled = false, heading = 'Choose Style' }) => {
    const [templates, setTemplates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadTemplates = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const getTemplatesFunc = httpsCallable(functions, 'getPromptTemplates');
            const result = await getTemplatesFunc();
            if (result.data?.templates && Array.isArray(result.data.templates)) {
                setTemplates(result.data.templates.filter(t => t.enabled !== false));
            }
        } catch (err) {
            console.error('Error loading templates:', err);
            setError('Unable to load styles right now.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        loadTemplates();
    }, [loadTemplates]);

    return (
        <div className="style-picker">
            {heading && <h3 className="style-picker-heading">{heading}</h3>}
            {error && <div className="style-picker-error">{error}</div>}
            {isLoading ? (
                <div className="style-picker-loading">Loading styles...</div>
            ) : (
                <div className="style-picker-grid">
                    {templates.map(template => (
                        <button
                            type="button"
                            key={template.id}
                            className={`style-picker-card ${selectedTemplateId === template.id ? 'selected' : ''}`}
                            onClick={() => !disabled && onSelect?.(template)}
                            disabled={disabled}
                        >
                            {template.previewImageUrl && (
                                <img
                                    src={template.previewImageUrl}
                                    alt={template.name}
                                    className="style-picker-preview"
                                />
                            )}
                            <span className="style-picker-name">{template.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StylePicker;
